import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import ReactGA from "react-ga";
import "./App.scss";
import AnimatedRoutesComponent from "./components/AnimatedRoutesComponent";

const TrackingId = "G-PVQK8RV2L7";
ReactGA.initialize(TrackingId);

function App() {
  return (
    <Router>
      <AnimatedRoutesComponent />
    </Router>
  );
}

export default App;
